<script>
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'

export default {
  name: 'IframeView',
  components: { DefaultLayout, EventNavbar },
  data() {
    return { pageTitle: '' }
  },
  computed: {
    iframeSrc() {
      const path = this.$route.fullPath
      const sep = path.includes('?') ? '&' : '?'
      return path + sep + 'bare=1'
    }
  },
  methods: {
    onIframeLoad() {
      try {
        this.pageTitle = this.$refs.iframe.contentDocument.title || ''
      } catch (e) {
        // cross-origin fallback
      }
    }
  }
}
</script>

<template>
  <default-layout>
    <event-navbar :title="pageTitle" />
    <iframe
      ref="iframe"
      :src="iframeSrc"
      @load="onIframeLoad"
      style="width: 100%; height: calc(100vh - 112px); border: none;"
      title="content"
    ></iframe>
  </default-layout>
</template>
